// extracted by mini-css-extract-plugin
module.exports = {"container":"AccessFetchError_container__JM7KT","header":"AccessFetchError_header__14MRA","title":"AccessFetchError_title__j6a-v","content":"AccessFetchError_content__2c4__"};